import type { ComboboxItem } from '@mantine/core';
import { Checkbox, Flex, Stack, Text } from '@mantine/core';
import slugify from 'slugify';
import classes from './MultiOption.module.css';

type MultiOptionItem = ComboboxItem & { subLabel?: string };
type RenderOptionInput = {
  option: MultiOptionItem;
  checked: boolean;
  disabled?: boolean;
};

export const renderMultiOption = ({
  option,
  checked,
  disabled = false,
}: RenderOptionInput) => (
  <Flex align="center" justify="space-between" w="100%" gap="sm">
    <Stack gap={0} flex={1} miw={0}>
      <Text
        size="md"
        fw={500}
        c={disabled ? 'var(--os-mainColor-foreground-tertiary)' : undefined}
        data-testid={option.label}
        className={classes.nonInteractive}
        truncate
      >
        {option.label}
      </Text>
      {option.subLabel && (
        <Text size="xs" c="dimmed" truncate>
          {option.subLabel}
        </Text>
      )}
    </Stack>
    <Checkbox
      checked={checked}
      readOnly
      disabled={disabled}
      size="md"
      tabIndex={-1}
      classNames={{
        root: classes.nonInteractive,
        ...(disabled
          ? { input: classes.disabledInput, icon: classes.disabledIcon }
          : {}),
      }}
      data-testid={`checkbox-${slugify(option.label.toString(), { lower: true })}`}
    />
  </Flex>
);
